import moment from 'moment';
import { parse, ParsedQuery } from 'query-string';
import { CurrencyIsoCode, TransactionStatus } from 'shared/data/wallets/v1';

import { type FilterValues } from '../TransactionsFilter/TransactionsFilter.types';

export const normalizeFilterValues = (filter: FilterValues) => {
    return {
        ...filter,
        createdAtGte: filter.createdAtGte ? moment(filter.createdAtGte).format('YYYY-MM-DD') : undefined,
        createdAtLte: filter.createdAtLte ? moment(filter.createdAtLte).format('YYYY-MM-DD') : undefined,
    };
};

const getArrayValueFromSearch = (key: string, values: ParsedQuery) => {
    const value = values[key];

    if (!value) {
        return [];
    }

    return typeof value === 'string' ? [value] : value;
};

export const parseFilterValuesFromQuery = (search: string): FilterValues => {
    const values = parse(search);

    return {
        currencies: getArrayValueFromSearch('currencies', values) as CurrencyIsoCode[],
        statuses: getArrayValueFromSearch('statuses', values) as TransactionStatus[],
        createdAtGte: typeof values.createdAtGte === 'string' ? new Date(values.createdAtGte) : null,
        createdAtLte: typeof values.createdAtLte === 'string' ? new Date(values.createdAtLte) : null,
        accountAmountGte: typeof values.accountAmountGte === 'string' ? Number(values.accountAmountGte) : null,
        accountAmountLte: typeof values.accountAmountLte === 'string' ? Number(values.accountAmountLte) : null,
    };
};
